<lib-custom-modal [title]="refineTheseResultsTitle"
  [modalSize]="'large'"
  (close)="hideModal('modalClose')"
  class="refine-result"
  #RefineTheseResultsModal>
  <ng-container class="app-modal-body">
    <div class="border-top"></div>
    <div class="row" [class.d-none]="(type!=='')">
      <div class="col-md-3 mt-3">
        <h5>Claim Number</h5>
      </div>
      <div class="col-md-3 mt-1">
        <lib-select #claimNumberSelectionTemplate
          (change)="claimFieldHideShow($event)"
          [group]="RefindResultForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-select>
      </div>
      <div class="col-md-3"
        *ngIf="!hideClaimFeild">
        <lib-input [field]="ClaimNumberValue"
          (focusout)="dropdownValidationMain(RefindResultForm.controls['select_'+claimNumberData.columnId],RefindResultForm.controls['c_'+claimNumberData.columnId])"
          [group]="RefindResultForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-input>
      </div>
    </div>

    <ng-container [formGroup]="RefindResultForm">

      <div *ngFor="let field of columns">
        <div class="row" *ngIf="!field.columnType">
          <div class="col-md-3 mt-3">
            <h5>{{field.displayColumnName}}</h5>
          </div>
          </div>
        <app-dynamic-form [field]="field"
          [form]="this.RefindResultForm"
          [optionsD]="optionsData"
          [control]="RefindResultForm.get('c_'+field.columnId)" *ngIf="field.columnType"></app-dynamic-form>
      </div>
    </ng-container>
    <div class="border-bottom"></div>
  </ng-container>
  <ng-container class="app-modal-footer">
    <div class="d-flex justify-content-between align-items-center">
      <div class="col-sm-3">
        <button #cancelResultsBtnTemplate
          class="btn-secondary p-2"
          (click)="hideModal('modalCancel')" [attr.data-dl]="JSON.stringify({da_track: 'true'})">Cancel</button>
      </div>
      <div class="col-sm-7 d-flex justify-content-around">
        <div class="col-md-5">
          <button #resetBtnTemplate
            class="btn-sm btn-secondary p-2"
            (click)="resetModal()" [attr.data-dl]="JSON.stringify({da_track: 'true'})">Reset Criteria</button>
        </div>
        <div class="col-md-5">
          <button #refineResultsBtnTemplate
            class="btn-primary p-2"
            (click)="refineResultButton()" [attr.data-dl]="JSON.stringify({da_track: 'true'})">Refine Results</button>
        </div>
      </div>
    </div>
  </ng-container>
</lib-custom-modal>
